import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/"
)({
  beforeLoad({ params }) {
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/billing/overview",
      params,
    });
  },
});
